import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'

import { Center, Grid, Tooltip } from '@chakra-ui/react'

interface EditRemoveButtonIProps {
  handleOnEdit: () => void
  handleOnDelete?: () => void
  showEdit?: boolean
  showDelete?: boolean
  disabled?: boolean
  disabledTooltip?: string
  disabledDelete?: boolean
  disabledDeleteTooltip?: string
}

export const EditRemoveButton = ({
  handleOnEdit,
  handleOnDelete,
  showEdit = true,
  showDelete = true,
  disabled = false,
  disabledTooltip,
  disabledDelete = false,
  disabledDeleteTooltip,
}: EditRemoveButtonIProps) => {
  // A lone button keeps the height it would have alongside a sibling
  // (half the container minus half the gap) and centers in the row.
  const isSingleButton = !(showEdit && showDelete)

  const isDeleteDisabled = disabled || disabledDelete

  const content = (
    <Grid
      alignContent={isSingleButton ? 'center' : undefined}
      gap='10px'
      gridTemplateRows={isSingleButton ? 'calc(50% - 5px)' : '1fr 1fr'}
      h='full'
      maxW='100%'
      ml='10px'
    >
      {showEdit && (
        <Center
          _hover={disabled ? {} : { bgColor: '#d2d2d4' }}
          bgColor='#E5E8EE'
          boxShadow={disabled ? 'none' : '0 2px 7px 0 rgba(50,121,199,0.5)'}
          cursor={disabled ? 'not-allowed' : 'pointer'}
          data-testid={`EditRemoveButton:edit${disabled ? '-disabled' : ''}`}
          h='full'
          onClick={disabled ? undefined : handleOnEdit}
          opacity={disabled ? 0.5 : 1}
          rounded='5px'
          transition='ease-in-out'
          transitionDuration='300ms'
          transitionProperty='background-color'
          w='60px'
        >
          <HiOutlinePencil color='#3279C7' size='24px' />
        </Center>
      )}
      {showDelete && (
        <Tooltip
          hasArrow
          isDisabled={disabled || !disabledDelete || !disabledDeleteTooltip}
          label={disabledDeleteTooltip}
          placement='left'
        >
          <Center
            _hover={isDeleteDisabled ? {} : { bgColor: '#b40e2a' }}
            bgColor='#D01030'
            boxShadow={
              isDeleteDisabled ? 'none' : '0 2px 7px 0 rgba(189,25,25,0.5)'
            }
            cursor={isDeleteDisabled ? 'not-allowed' : 'pointer'}
            data-testid={`EditRemoveButton:delete${
              isDeleteDisabled ? '-disabled' : ''
            }`}
            h='full'
            onClick={isDeleteDisabled ? undefined : handleOnDelete}
            opacity={isDeleteDisabled ? 0.5 : 1}
            rounded='5px'
            transition='ease-in-out'
            transitionDuration='300ms'
            transitionProperty='background-color'
            w='60px'
          >
            <HiOutlineTrash color='#fff' size='24px' />
          </Center>
        </Tooltip>
      )}
    </Grid>
  )

  if (disabled && disabledTooltip) {
    return (
      <Tooltip hasArrow label={disabledTooltip} placement='left'>
        {content}
      </Tooltip>
    )
  }

  return content
}
